import 'regenerator-runtime/runtime';
import { AnyAction } from 'redux';
import { GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { ChildState } from '../mappers/childStates';

export const sharedDispatcher = (): GlobalEventDispatcher =>
  (window as unknown as Record<string, GlobalEventDispatcher>)['globalEventDispatcher'];

export const dispatchToStoreOf = (
  app: App,
  angebotsId: string | undefined,
  action: AnyAction,
): boolean => {
  const storeRef = sharedDispatcher().stores.find(
    ref => ref.appName === app && ref.angebotsId === angebotsId,
  );
  if (!storeRef) {
    return false;
  }
  storeRef.store.dispatch(action);
  return true;
};

export const findStoreState = (app: App, angebotsId?: string): ChildState | undefined => {
  try {
    return sharedDispatcher().getStateByAngebot(app, angebotsId);
  } catch {
    return undefined;
  }
};
